/**
 * Reusable SMS verification service. Used by reservation and (future) order flows.
 * Single place for "request SMS code" — calls generic POST /api/public/verify/request-code.
 * See docs/API-REFERENCE.md (Public SMS verification).
 */

import api from './api'

/**
 * Request an SMS verification code by purpose and scope (no auth).
 * @param {{
 *   purpose: 'reservation' | 'order',
 *   scope: string,
 *   customer_mobile: string
 * }} params - purpose: 'reservation' | 'order'; scope: e.g. restaurant slug; customer_mobile: +country code
 * @returns {Promise<{ message: string, verification_token: string }>}
 */
export async function requestCode({ purpose, scope, customer_mobile }) {
  const { data } = await api.post(
    '/public/verify/request-code',
    { purpose, scope, customer_mobile },
    { skipAuth: true }
  )
  return data
}

export const verificationService = {
  requestCode,
}

export default verificationService
